<footer class="gb-footer-simple text-base-content">
  <div class="gb-charity-shell">
    <div class="grid gap-10 py-12 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-16">
      <!-- Brand and contact -->
      <div>
        <a class="inline-flex items-center gap-3 no-underline" [routerLink]="AppRoutes.home()">
          @if (ctx.charity?.logo?.color) {
            <span class="gb-footer-simple__logo">
              <img [src]="ctx.charity?.logo?.color" [alt]="brandName + ' logo'" />
            </span>
          }
          <span class="gb-footer-simple__brand">{{ brandName }}</span>
        </a>
        @if (ctx.charity?.phone || ctx.charity?.email) {
          <ul class="m-0 mt-6 flex list-none flex-col gap-2.5 p-0 text-[15px]">
            @if (ctx.charity?.phone; as phone) {
              <li class="flex items-center gap-3">
                <ui-icon name="phone" [size]="16" class="shrink-0 text-base-content/70" />
                <a class="gb-footer-simple__link" [href]="'tel:' + phone">{{ phone }}</a>
              </li>
            }
            @if (ctx.charity?.email; as email) {
              <li class="flex items-center gap-3">
                <ui-icon name="mail" [size]="16" class="shrink-0 text-base-content/70" />
                <a class="gb-footer-simple__link" [href]="'mailto:' + email">{{ email }}</a>
              </li>
            }
          </ul>
        }
      </div>

      <!-- Link columns -->
      <nav class="grid grid-cols-2 gap-8 sm:grid-cols-3" aria-label="Footer">
        <div>
          <h2 class="gb-footer-simple__heading">Donate</h2>
          <ul class="gb-footer-simple__links">
            <li><a [routerLink]="AppRoutes.discover()">All campaigns</a></li>
            <li><a [routerLink]="fundraisePath">Start a fundraiser</a></li>
          </ul>
        </div>
        <div>
          <h2 class="gb-footer-simple__heading">{{ brandName }}</h2>
          <ul class="gb-footer-simple__links">
            <li><a [routerLink]="AppRoutes.home()" fragment="about-heading">About</a></li>
            <li><a [href]="givebriteSupport" rel="noopener">Support</a></li>
          </ul>
        </div>
        <div>
          <h2 class="gb-footer-simple__heading">Your account</h2>
          <ul class="gb-footer-simple__links">
            <li><a [routerLink]="AppRoutes.dashboard.root()">User dashboard</a></li>
          </ul>
        </div>
      </nav>
    </div>

    <div class="h-px bg-base-content/10"></div>

    <div
      class="flex flex-col gap-3 py-5 text-[13px] text-base-content/60 sm:flex-row sm:items-center sm:justify-between"
    >
      <p class="m-0">
        &copy; {{ year }} {{ brandName }}
        @if (ctx.charity?.registrationNumber; as registrationNumber) {
          · Registered charity {{ registrationNumber }}
        }
      </p>
      <div class="flex flex-wrap items-center gap-x-5 gap-y-2">
        <a class="gb-footer-simple__link" [href]="givebriteTerms" rel="noopener">Terms</a>
        <a class="gb-footer-simple__link" [href]="givebritePrivacy" rel="noopener">Privacy</a>
        @if (!ctx.charity?.enableIncognito) {
          <a
            class="gb-footer-simple__link inline-flex items-center gap-1.5 whitespace-nowrap"
            [href]="AppRoutes.external.givebriteHome()"
            rel="noopener"
          >
            <span>Powered by</span>
            <img class="h-4 w-auto shrink-0" [src]="PLATFORM_LOGO_SRC" alt="Givebrite" />
          </a>
        }
      </div>
    </div>
  </div>
</footer>
